/** @jsxImportSource @emotion/react */
import { Global, css } from '@emotion/react';

// TODO - @aniket - update to use mui theming
export const GlobalStyles = () => (
  <Global
    styles={css`
      code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
      }

      *,
      ::before,
      ::after {
        box-sizing: border-box;
      }

      html,
      body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        scroll-behavior: smooth;
      }

      html {
        font-size: 62.5%;
      }

      body {
        box-sizing: border-box;
        font-family: Roboto, sans-serif;
        height: 100%;
        width: 100%;
        min-width: 1366px;
        min-height: 768px;
      }

      #root {
        height: 100%;
        width: 100%;
      }

      h1 {
        font-size: 4.8rem;
        font-weight: normal;
      }

      h2 {
        font-size: 4rem;
        font-weight: normal;
      }
    `}
  />
);
